module.exports = __webpack_public_path__ + "static/media/chicken-nuggets-mb-en.08b31720.jpg";